export const play = (
  <path
    d="M8 22.5V5.5L22.5 14L8 22.5Z"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinejoin="bevel"
  />
);

export const playFill = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.50572 4.6373L7 5.5V22.5L8.50572 23.3627L23.0057 14.8627V13.1373L8.50572 4.6373Z"
    fill="currentColor"
  />
);

export const pause = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9 5V23H11V5H9ZM17 5V23H19V5H17Z"
    fill="currentColor"
  />
);

export const pauseFill = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.4 5H8.1L7 6V22L8.1 23H11.4L12.5 22V6L11.4 5ZM19.9 5H16.6L15.5 6V22L16.6 23H19.9L21 22V6L19.9 5Z"
    fill="currentColor"
  />
);

export const stop = (
  <path
    d="M6 22V6H22V22H6Z"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinejoin="bevel"
  />
);

export const stopFill = (
  <path d="M6 5L5 6V22L6 23H22L23 22V6L22 5H6Z" fill="currentColor" />
);

export const power = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13 2.5V13.5H15V2.5H13ZM8.67361 7.05732C6.58996 8.65855 5.25 11.1726 5.25 14C5.25 18.8325 9.16751 22.75 14 22.75C18.8325 22.75 22.75 18.8325 22.75 14C22.75 11.1726 21.41 8.65855 19.3264 7.05732L20.5451 5.47149C23.1001 7.43498 24.75 10.525 24.75 14C24.75 19.937 19.9371 24.75 14 24.75C8.06294 24.75 3.25 19.937 3.25 14C3.25 10.525 4.8999 7.43498 7.45495 5.47149L8.67361 7.05732Z"
    fill="currentColor"
  />
);

export const move = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13.2109 2.99606L14.789 2.99606L14.7892 2.9959L14.7892 2.99597L14.7893 2.99606L14.7914 2.99868L14.8021 3.01229C14.8121 3.02494 14.8277 3.04462 14.8488 3.07075C14.8908 3.12303 14.9543 3.20104 15.0372 3.30013C15.203 3.49848 15.4455 3.78032 15.7476 4.10873C16.3553 4.76927 17.1888 5.60113 18.1139 6.32065L16.886 7.89936C15.8424 7.08762 14.9259 6.16949 14.2757 5.46284C14.178 5.35659 14.0859 5.25473 14 5.15829C13.914 5.25473 13.8219 5.35659 13.7242 5.46284C13.0741 6.16949 12.1576 7.08762 11.1139 7.89936L9.88602 6.32065C10.8111 5.60113 11.6446 4.76927 12.2523 4.10873C12.5544 3.78032 12.7969 3.49848 12.9627 3.30013C13.0456 3.20104 13.1091 3.12303 13.1512 3.07075C13.1722 3.04462 13.1878 3.02494 13.1978 3.01229L13.2086 2.99868L13.2106 2.99606L13.2107 2.99597L13.2107 2.9959L13.2109 2.99606ZM14.789 25.0039H13.2109L13.2107 25.0041L13.2107 25.004L13.2106 25.0039L13.2086 25.0013L13.1978 24.9877C13.1878 24.9751 13.1722 24.9554 13.1512 24.9293C13.1091 24.877 13.0456 24.799 12.9627 24.6999C12.7969 24.5015 12.5544 24.2197 12.2523 23.8913C11.6446 23.2307 10.8111 22.3989 9.88602 21.6794L11.1139 20.1007C12.1576 20.9124 13.0741 21.8305 13.7242 22.5372C13.8219 22.6434 13.914 22.7453 14 22.8417C14.0859 22.7453 14.178 22.6434 14.2757 22.5372C14.9259 21.8305 15.8424 20.9124 16.886 20.1007L18.1139 21.6794C17.1888 22.3989 16.3553 23.2307 15.7476 23.8913C15.4455 24.2197 15.203 24.5015 15.0372 24.6999C14.9543 24.799 14.8908 24.877 14.8488 24.9293C14.8277 24.9554 14.8121 24.9751 14.8021 24.9877L14.7914 25.0013L14.7893 25.0039L14.7892 25.004L14.7892 25.0041L14.789 25.0039ZM25.0039 14.789V13.211L25.0041 13.2108L25.004 13.2107L25.0039 13.2106L25.0013 13.2086L24.9877 13.1979C24.975 13.1879 24.9553 13.1722 24.9292 13.1512C24.8769 13.1091 24.7989 13.0456 24.6998 12.9628C24.5015 12.797 24.2196 12.5545 23.8912 12.2523C23.2307 11.6447 22.3988 10.8112 21.6793 9.88606L20.1006 11.1139C20.9123 12.1576 21.8305 13.0741 22.5371 13.7242C22.6434 13.822 22.7452 13.914 22.8417 14C22.7452 14.0859 22.6434 14.178 22.5371 14.2758C21.8305 14.9259 20.9123 15.8424 20.1006 16.8861L21.6793 18.1139C22.3988 17.1888 23.2307 16.3553 23.8912 15.7476C24.2196 15.4455 24.5015 15.203 24.6998 15.0372C24.7989 14.9544 24.8769 14.8909 24.9292 14.8488C24.9553 14.8278 24.975 14.8121 24.9877 14.8021L25.0013 14.7914L25.0039 14.7894L25.004 14.7893L25.0041 14.7892L25.0039 14.789ZM2.99602 14.789L2.99602 13.211L2.99585 13.2108L2.99592 13.2107L2.99602 13.2106L2.99863 13.2086L3.01225 13.1979C3.02489 13.1879 3.04458 13.1722 3.07071 13.1512C3.12299 13.1091 3.20099 13.0456 3.30008 12.9628C3.49843 12.797 3.78027 12.5545 4.10868 12.2524C4.76923 11.6447 5.60109 10.8112 6.32061 9.88606L7.89931 11.1139C7.08758 12.1576 6.16944 13.0741 5.4628 13.7242C5.35654 13.822 5.25468 13.9141 5.15825 14C5.25468 14.086 5.35654 14.178 5.4628 14.2758C6.16944 14.9259 7.08758 15.8424 7.89931 16.8861L6.32061 18.1139C5.60109 17.1888 4.76923 16.3553 4.10868 15.7477C3.78027 15.4455 3.49843 15.203 3.30008 15.0372C3.20099 14.9544 3.12298 14.8909 3.07071 14.8488C3.04458 14.8278 3.02489 14.8121 3.01225 14.8021L2.99863 14.7914L2.99602 14.7894L2.99592 14.7893L2.99585 14.7892L2.99602 14.789ZM13.9999 17.5C15.9329 17.5 17.4999 15.933 17.4999 14C17.4999 12.067 15.9329 10.5 13.9999 10.5C12.067 10.5 10.4999 12.067 10.4999 14C10.4999 15.933 12.067 17.5 13.9999 17.5Z"
    fill="currentColor"
  />
);
